export const titleList = [
  {
    value: "Mr",
    name: "Mr",
  },
  {
    value: "Mrs",
    name: "Mrs",
  },
  {
    value: "Ms",
    name: "Ms",
  },
  {
    value: "Dr",
    name: "Dr",
  },
];
export const firmsList = [
  { value: "Public Limited Company", name: "Public Limited Company" },
  {
    value: "Public Sector Undertaking (Govt.)",
    name: "Public Sector Undertaking (Govt.)",
  },
  {
    value: "One Person Company (OPC) Limited",
    name: "One Person Company (OPC) Limited",
  },
  { value: "Partnership Firm", name: "Partnership Firm" },
  { value: "Proprietorship", name: "Proprietorship" },
  { value: "Trust / NGO", name: "Trust / NGO" },
  { value: "Individual", name: "Individual" },
  { value: "Joint Venture", name: "Joint Venture" },
  {
    value: "Limited Liability Partnership",
    name: "Limited Liability Partnership",
  },
];
